import styled from 'react-emotion';

export const H1 = styled.h1`
	align-items: baseline;
	display: flex;
	flex-wrap: wrap;
	font-size: 2.25rem;
	font-weight: 500;
	line-height: 1.3;
	padding-top: 2rem;

	@media (max-width: 480px) {
		font-size: 1.625rem;
		padding: 1rem 0;
	}
`;

export const Subtitle = styled.span`
	display: inline-block;
	font-size: 0.875rem;
	font-weight: 300;
`;

export const Dash = styled.span`
	display: inline-block;
	font-size: 0.875rem;
	font-weight: 300;
`;
